import React, { createContext, useCallback, useState, useContext } from 'react';
import { Auth } from 'aws-amplify';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const user = localStorage.getItem('@Claro-Catalogo:user');
    const token = localStorage.getItem('@Claro-Catalogo:token');

    if (user && token) {
      return { user: JSON.parse(user), token };
    }

    return {};
  });

  const signIn = useCallback(async (user, token) => {
    localStorage.setItem('@Claro-Catalogo:token', token);
    localStorage.setItem('@Claro-Catalogo:user', JSON.stringify(user));

    setData({ user, token });
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@Claro-Catalogo:token');
    localStorage.removeItem('@Claro-Catalogo:user');
    localStorage.removeItem('@Claro-Catalogo:result');
    localStorage.removeItem('_grecaptcha');

    try {
      Auth.signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }

    setData({});
  }, []);

  return (
    <AuthContext.Provider value={{ user: data.user, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export { AuthProvider, useAuth };
